import { AntSpin } from 'components/ant/AntSpin/AntSpin';
import { FC } from 'react';

export const PageLoader: FC = () => {
  return <AntSpin size="large" />;
};
